<template>
    <div class="supplier-statistics-report-container">
        <div class="t-top-bar">
            <div class="report-op">
              <el-select id="supplierSelect" filterable clearable class="search-input" v-model="supplierId" placeholder="选择客户">
                <el-option v-for="(val,key) in supplierList" :key="key" :label="val.supplierName" :value="val.supplierId"></el-option>
              </el-select>
              <el-select id="productionSelect" filterable clearable class="search-input" v-model="productionId" @change="productionChange" placeholder="选择产品">
                <el-option v-for="(val,key) in productionList" :key="key" :label="val.productionName" :value="val.productionId"></el-option>
              </el-select>
              <el-select id="productionSelect" filterable clearable class="search-input" v-model="specId" placeholder="选择规格">
                <el-option v-for="(val,key) in specList" :key="key" :label="val.specName" :value="val.specId"></el-option>
              </el-select>
              <el-date-picker style="margin-right: 15px;"  v-model="selectTime" type="datetimerange"
                               range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                               align="right"></el-date-picker>
              <el-select id="orderSelect" class="search-input orderSelect" v-model="selectOrderId" multiple collapse-tags @change="orderChange" placeholder="请选择单号">
                <el-option v-for="item in orderIdArr" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>

            </div>
            <div class="report-op"><el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button></div>
          <div class="report-op"><el-button style="margin: 0" type="primary"  @click="print">打印</el-button></div>
            <div class="report-op"><i class="el-icon-download l-add-buttion" @click="exportExcel"></i></div>
        </div>
        <el-table id="printTable" :data="tableData" border style="width: 100%" :span-method="arraySpanMethod"  height="640" v-loading="listLoading">
          <el-table-column prop="order_id" label="单号" class-name="numtostr" width="250"></el-table-column>
          <el-table-column prop="supplier_name" label="供应商" width="100"></el-table-column>
          <el-table-column prop="production_name" label="产品" width="100"></el-table-column>
          <el-table-column prop="spec_name" label="规格" width="100"></el-table-column>
          <el-table-column v-for="(val, key) in columns" :key="key" :label="val.name" :prop="val.key">
<!--            <template slot-scope="scope">-->
<!--              {{ (scope.row[val.key])||0}}-->
<!--            </template>-->
          </el-table-column>
          <el-table-column prop="price" label="单价/千克" width="100"></el-table-column>
          <el-table-column prop="sum_weight" width="180" label="总重/千克">
            <template slot-scope="scope">
              {{ (scope.row.sum_weight).toFixed(2)}}
            </template>
          </el-table-column>
          <el-table-column prop="sum_price" label="价格汇总">
            <template slot-scope="scope">
              {{ (scope.row.sum_price).toFixed(2)}}
            </template>
          </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import { getSupplierStatistics } from '../../api/record'
    import { tableDataToExcelSample, dataprint} from '../../util/util'
    import { getProductionList } from '../../api/prouction'
    import { getSupplierList } from '../../api/supplier'
    import { getDepartmentList } from '../../api/department'
    import localCache from "../../util/localCache";
    import {getSpecList} from "@/api/spec";
    export default {
        name: "supplierStatisticsReportContainer",
        data(){
            return {
                listLoading: false,
                tableHead: [],
                tableData: [],
                reportColumn: {
                  'total_price': '工资',
                  // 'calc_kg': '计价重量',
                  // 'delivery_kg': '交料重量'
                },
                selectColumn: 'total_price',
                pns:{
                  '剥虾':'剥虾',
                  '去头':'去头'
                },
                pn: '剥虾',
                selectTime: '',
                keyword: '',
                searchDepart:'',
                treeData: [],
                priceType:'',
                supplierId: '',
                supplierList: [],
              productionId: '',
              productionList: [],
              specList:[],
              specId: '',
              columnsNum: 10,
              columns: [],
              selectOrderId: [],
              orderIdArr: [],
              dataCache: [],
              orderCount: {},
              supplierCount: {},
              productCount: {},
              specCount: {},
              priceCount: {},
              weightCount: {},
              totoalPriceCount: {}
            }
        },
        mounted(){
          let now = new Date()
          let now1 = new Date(now.getFullYear(),now.getMonth(),now.getDate()-2,0,0);
          let end = new Date(now.getFullYear(),now.getMonth(),now.getDate(),0,0);
          // let now1 = new Date(2022,11,29,0,0,0);
          // let end = new Date(2022,11,29,23,59,59);
          this.selectTime = [now1,end]

          this.generateColumn()
          this.getProductionList_();
          this.getSupplierList_();
          this.getRecordList_()
        },
        methods: {
          generateColumn(){
            let arr = []
            for (let i = 0; i < this.columnsNum; i++) {
              arr.push({
                name: ''+(i+1),
                key: 'c'+i
              })
            }
            this.columns = arr
          },
          getProductionList_(){
            getProductionList({
              customerId: localCache.getCurrentCustomerId()
            }).then(res => {
              if (res.errorcode !== 0) {
                this.$message.error(res.message)
              } else {
                this.productionList = res.data
              }
            }).catch(() => {
            })
          },
          getSupplierList_(){
            let param = {
              customerId: localCache.getCurrentCustomerId(),
            }
            getSupplierList(param).then(res => {
              if (res.errorcode !== 0) {
                this.$message.error(res.message)
              } else {
                this.supplierList = res.data
              }
            }).catch(() => {
            })
          },
          print(){
            var printHTML = document.getElementById('printTable').innerHTML; // 获取要打印的内容
            let selectProduction = document.getElementById('productionSelect').value
            let selectSupplier = document.getElementById('supplierSelect').value
            let orderId = this.selectOrderId[0] || ''
            let date = new Date(this.selectTime[0])
            let time = `${date.getFullYear()}年${date.getMonth()+1}月${date.getDate()}日`
            let t = `<table><tr>
                        <td colspan="3">客户名称：${selectSupplier}</td>
                        <td colspan="3">产品名称：${selectProduction}</td>
                        <td colspan="3">时间：${time}</td>
                        <td colspan="3">单号：${orderId}</td>
                        </tr></table>`
            console.log(printHTML)
            dataprint(t+printHTML)
          },
          arraySpanMethod({ row, column, rowIndex, columnIndex }){
            if(row.last){
              if(columnIndex == 0){
                return row.span
              }else if(columnIndex>0 && columnIndex <= this.columnsNum+3){
                return {
                  rowspan: 1,
                  colspan: 0
                }
              }
              return {
                rowspan: 1,
                colspan: 1
              }
            }else{
              if("order_id" == column.property){
                return this.rowspan(this.orderCount, row.order_id)
              }else if("supplier_name" == column.property){
                return this.rowspan(this.supplierCount, row.order_id+row.supplier_id)
              }else if("production_name" == column.property){
                return this.rowspan(this.productCount, row.order_id+row.supplier_id+row.production_id)
              }else if("spec_name" == column.property){
                return this.rowspan(this.specCount, row.order_id+row.supplier_id+row.production_id+row.spec_id)
              }else if("price" == column.property){
                return this.rowspan(this.priceCount, row.order_id+row.supplier_id+row.production_id+row.spec_id)
              }else if("sum_weight" == column.property){
                return this.rowspan(this.weightCount, row.order_id+row.supplier_id+row.production_id+row.spec_id)
              }else if("sum_price" == column.property){
                return this.rowspan(this.totoalPriceCount, row.order_id)
              }
            }

          },
          rowspan(obj, key){
            let v = obj[key]
            if(v == 1){
              return [1,1]
            }else if(v==0){
              return [0,0]
            }else{
              obj[key] = 0
              return [v, 1]
            }
          },
            exportExcel(){
              // let date = new Date(this.selectTime)
              let title = `原料采购单`
              let str = document.querySelector('.el-table__header').innerHTML
              let body = document.querySelector('.el-table__body').innerHTML
              let selectProduction = document.getElementById('productionSelect').value
              let selectSupplier = document.getElementById('supplierSelect').value
              let orderId = this.selectOrderId[0] || ''
              let date = new Date(this.selectTime[0])
              let time = `${date.getFullYear()}年${date.getMonth()+1}月${date.getDate()}日`
              let t = `<tr>
                        <td colspan="3">客户名称：${selectProduction}</td>
                        <td colspan="3">产品名称：${selectSupplier}</td>
                        <td colspan="3">时间：${time}</td>
                        <td colspan="3">单号：${orderId}</td>
                        </tr>`

              tableDataToExcelSample(t+str+body,title)
            },
            search(){
                this.getRecordList_()
            },
          orderChange(val){
            console.log(val)
            if(val.length==0){
              this.tableData = this.parseData0(this.dataCache.slice())
            }else{
              let arr = this.dataCache.slice().filter((t)=>{
                return val.indexOf(t.order_id)>-1
              })
              this.tableData = this.parseData0(arr)
            }
          },
          productionChange(val){
            if(!val){
              this.specList = []
              return
            }
            this.getSpecList_(val)

          },
          getSpecList_(productionId) {
            let param = {
              customerId: localCache.getCurrentCustomerId(),
              productionId: productionId
            }
            getSpecList(param).then(res => {
              if (res.errorcode !== 0) {
                this.$message.error(res.message)
              } else {
                this.specList = res.data
              }
            }).catch(() => {

            })
          },
          getRecordList_(){
            this.selectOrderId = []
            this.orderIdArr = []
                if(!this.selectTime){
                    this.$message.error('请选择时间')
                    return
                }
                this.listLoading = true
                let departmentId = ''
                if(this.searchDepart){
                    departmentId = this.searchDepart[this.searchDepart.length-1]
                }
                let param = {
                  customerId: localCache.getCurrentCustomerId(),
                  beginTime: parseInt(this.selectTime[0].getTime()/1000),
                  endTime: parseInt(this.selectTime[1].getTime()/1000),
                  productionId:this.productionId,
                  supplierId:this.supplierId,
                  specId: this.specId
                }
            getSupplierStatistics(param).then(res => {
                    this.listLoading = false
                    if (res.errorcode !== 0) {
                        this.$message.error(res.message)
                    } else {
                      this.dataCache = res.data.slice(0)
                        this.tableData = this.parseData0(res.data)
                    }
                }).catch(() => {
                    this.listLoading = false
                })
            },
            datasort(data){
              return data.sort((t1,t2)=>{
                let t1s = t1.spec_name.replace('/','')
                let t2s = t2.spec_name.replace('/','')
                if(t1s>t2s){
                  return 1
                }else if(t1s<t2s){
                  return -1;
                }else{
                  if(t1.record_time>t2.record_time){
                    return  1
                  }else{
                    return 1
                  }
                }
              })
            },
            parseData(data0){
              let data = this.datasort(data0)
              let t
              let d = []
              let o = {}
              let date = {}
              let weightSum = {}
              let sum = 0
              let preSpecId = ''
              let n = -1
              let line = {}
              let orderIdSet = new Set()
              for (let i = 0,len = data.length; i < len; i++) {
                t = data[i]
                orderIdSet.add(t.order_id)
                let k = t.spec_id+t.price_id
                if(!line[k]){
                  line[k] = 1
                }else{
                  line[k]++
                }
                let key = t.spec_id+t.price_id+ parseInt((line[k]-1)/this.columnsNum)

                if(preSpecId != t.spec_id || (line[k]-1)%this.columnsNum==0){
                  n = -1
                }
                n++
                console.log(key, t.dispatch_kg,n)
                if(!o[key]){
                  o[key] = {
                    production_id: t.production_id,
                    spec_id: t.spec_id,
                    production_name: t.production_name,
                    spec_name: t.spec_name,
                    price_id: t.price_id,
                    price: t.price,
                    total_price: t.total_price,
                    sum_weight: 0,
                    ['c'+n]: t.dispatch_kg
                  }
                  d.push(o[key])
                }else{
                  o[key]['c'+n] =  t.dispatch_kg
                }
                preSpecId = t.spec_id

                if(!weightSum[k]){
                  weightSum[k] = 0;
                }
                weightSum[k] += t.dispatch_kg
                if(!date[k]){
                  date[k] = o[key]
                }else{
                  if(!date[k].span){
                    date[k].span = {
                      rowspan: 1,
                      colspan: 1
                    }
                  }else{
                    date[k].span.rowspan = Math.ceil(line[k]/this.columnsNum)
                  }
                  // o[key].span = {
                  //   rowspan: 0,
                  //   colspan: 0
                  // }
                }

              }
              let lastSumWeight=0
              let lastSumPrice=0
              console.log('line',line)
              d.forEach((t)=>{
                t.sum_weight = weightSum[t.spec_id+t.price_id]
                t.sum_price = t.price * t.sum_weight
                lastSumWeight += t.sum_weight
                lastSumPrice += t.sum_price
                if(!t.span){
                  if(line[t.spec_id+t.price_id]>1){
                    t.span = {
                      rowspan: 0,
                      colspan: 0
                    }
                  }
                }
              })
              let last = {
                'last': true,
                'spec_name':'签字：',
                'price': '--',
                'sum_weight':lastSumWeight,
                'sum_price':lastSumPrice,
                'span':{
                  rowspan: 1,
                  colspan: this.columnsNum+1
                }
              }
              d.push(last)
              let arr = []
              orderIdSet.forEach((t)=>{
                arr.push({
                  label: t,
                  value: t
                })
              })
              if(!this.orderIdArr || this.orderIdArr.length==0){
                this.orderIdArr = arr
                if(this.orderIdArr.length == 1){
                  this.selectOrderId = [this.orderIdArr[0].value]
                }
              }

              return d
            },
          datasort0(data){
            return data.sort((t1,t2)=>{
              let t1orderId = t1.order_id
              let t2orderId = t2.order_id
              if(t1orderId > t2orderId){
                return 1
              }else if(t1orderId < t2orderId){
                return -1;
              }else{
                let t1supplierId = t1.supplier_name
                let t2supplierId = t2.supplier_name
                if(t1supplierId > t2supplierId){
                  return 1
                }else if(t1supplierId < t2supplierId){
                  return -1;
                }else{
                  let t1proId = t1.production_name.replace('/','')
                  let t2proId = t2.production_name.replace('/','')
                  if(t1proId > t2proId){
                    return 1
                  }else if(t1proId < t2proId){
                    return -1;
                  }else{
                    let t1s = t1.spec_name.replace('/','')
                    let t2s = t2.spec_name.replace('/','')
                    if(t1s>t2s){
                      return 1
                    }else if(t1s<t2s){
                      return -1;
                    }else{
                      if(t1.record_time>t2.record_time){
                        return  1
                      }else{
                        return -1
                      }
                    }
                  }
                }
              }
            })
          },
          parseData0(data0){
            console.log('parseData0',data0)
            this.orderCount={}
            this.supplierCount= {}
            this.productCount={}
            this.specCount={}
            this.priceCount= {}
            this.weightCount={}
            this.totoalPriceCount= {}
            let data = this.datasort0(data0)
            let d = []
            let o = {}
            let weightSum = {}
            let orderIdSet = new Set()

            let orderId, supplierId, productId, specId
            let n = -1
            let line = {}
            let preKey
            let t
            for (let i = 0,len = data.length; i < len; i++) {
              t = data[i]
              orderId = t.order_id;
              supplierId = t.supplier_id;
              productId = t.production_id;
              specId = t.spec_id;

              orderIdSet.add(orderId)

              let k = orderId + supplierId + productId + specId;
              if(!line[k]){
                line[k] = 1
              }else{
                line[k]++
              }
              let key = k + parseInt((line[k]-1)/this.columnsNum)
              if(preKey != key){
                n = -1
              }
              n++
              if(!o[key]){
                o[key] = {
                  order_id: t.order_id,
                  supplier_id: t.supplier_id,
                  supplier_name: t.supplier_name,
                  production_id: t.production_id,
                  spec_id: t.spec_id,
                  production_name: t.production_name,
                  spec_name: t.spec_name,
                  price_id: t.price_id,
                  price: t.price,
                  total_price: t.total_price,
                  sum_weight: 0,
                  ['c'+n]: t.dispatch_kg
                }
                d.push(o[key])
              }else{
                o[key]['c'+n] =  t.dispatch_kg
              }
              preKey = key

              if(!weightSum[k]){
                weightSum[k] = 0;
              }
              weightSum[k] += t.dispatch_kg

            }
            console.log('parseData0',weightSum)
            console.log('parseData0',d)

            let lastSumWeight=0
            let lastSumPrice=0
            let that = this
            d.forEach((t)=>{
              let orderId = t.order_id
              if(!that.orderCount[orderId]){
                that.orderCount[orderId] = 1;
                that.totoalPriceCount[orderId] = 1;
              }else{
                that.orderCount[orderId] ++;
                that.totoalPriceCount[orderId] ++;
              }
              let supplierkey = orderId + t.supplier_id;
              if(!that.supplierCount[supplierkey]){
                that.supplierCount[supplierkey] = 1;
              }else{
                that.supplierCount[supplierkey] ++;
              }

              let productkey = supplierkey + t.production_id;
              if(!that.productCount[productkey]){
                that.productCount[productkey] = 1;
              }else{
                that.productCount[productkey] ++;
              }

              let speckey = productkey + t.spec_id;
              if(!that.specCount[speckey]){
                that.specCount[speckey] = 1;
                this.priceCount[speckey] = 1;
                this.weightCount[speckey] = 1;
              }else{
                that.specCount[speckey] ++;
                this.priceCount[speckey] ++
                this.weightCount[speckey] ++
              }

              t.sum_weight = weightSum[speckey]
              t.sum_price = t.price * t.sum_weight
              lastSumWeight += t.sum_weight
              lastSumPrice += t.sum_price
              weightSum[speckey] = 0
            })
            console.log('parseData0', lastSumWeight)
            let last = {
              'last': true,
              order_id: '签字：',
              supplier_id: '',
              supplier_name: '',
              production_id: '',
              spec_id: '',
              production_name: '',
              'spec_name':'',
              'price': '--',
              'sum_weight':lastSumWeight,
              'sum_price':lastSumPrice,
              'span':{
                rowspan: 1,
                colspan: this.columnsNum+4
              }
            }
            d.push(last)
            let arr = []
            orderIdSet.forEach((t)=>{
              arr.push({
                label: t,
                value: t
              })
            })
            if(!this.orderIdArr || this.orderIdArr.length==0){
              this.orderIdArr = arr
              if(this.orderIdArr.length == 1){
                this.selectOrderId = [this.orderIdArr[0].value]
              }
            }
            console.log(d)

            return d
          }
        }
    }
</script>

<style lang="scss">
    .supplier-statistics-report-container{
        .t-top-bar{
            display: flex;
        }
        .report-op{
            margin-right: 15px;
        }
        .report-op:last-child{
            margin-left: auto;
        }
        .search-input{
            width: 250px;
            margin-right: 15px;
        }
        .search-input200{
            width: 200px;
            margin-right: 15px;
        }
        .el-table td{
            padding: 0;
        }
        .orderSelect{
            width: 300px !important;
        }
    }

</style>
